import { useMutation } from "@tanstack/react-query";
import type { AxiosError, AxiosResponse } from "axios";

import type { SendUserDataRequest, WipeUserRequest } from "./api.dto";
import { useMutate } from "@/shared/hooks";

export const useWipe = ({ id }: WipeUserRequest) => {
  const { mutationFn, onSuccess, onError } = useMutate({
    method: "put",
    url: `/users/${id}/wipe`,
    toast: {
      success: {
        description: "Пользователь вайпнут.",
      },
    },
  });

  return useMutation<AxiosResponse, AxiosError, WipeUserRequest, Response>({
    mutationKey: ["wipeUser"],
    mutationFn,
    onSuccess,
    onError,
  });
};

export const useSendUserData = ({ _id }: SendUserDataRequest) => {
  const { mutationFn, onSuccess, onError } = useMutate({
    method: "post",
    url: `/users/${_id}/resend`,
    toast: {
      success: {
        description: "Данные пользователя отправлены.",
      },
    },
  });

  return useMutation<AxiosResponse, AxiosError, SendUserDataRequest, Response>({
    mutationKey: ["sendUserData"],
    mutationFn,
    onSuccess,
    onError,
  });
};
